module.exports = __webpack_public_path__ + "img/big3-13.c656e766.jpg";